import React from 'react';
import { isMadPawsStore } from '../../../common/util';

const FacetSelectedIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill={isMadPawsStore() ? 'var(--primary-default)' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.773438"
        y="0.5"
        width="19"
        height="19"
        rx="1.5"
        stroke={isMadPawsStore() ? 'var(--primary-default)' : '#C9D5DA'}
      />
      <path
        d="M5.07812 9.33083L8.53966 12.7924L15.0781 6.25391"
        stroke={isMadPawsStore() ? '#F5F5F3' : '#1990BA'}
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default FacetSelectedIcon;
